import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import { ComponentStore } from '@ngrx/component-store'

import * as state from '../../../../../../../../../state'

import { State } from './state'

/**
 * Local Page Builder configuration state for the page settings dialog.
 *
 * This store depends on Mosaic page entity state from the route-bound app
 * injector, so the Page Builder component owns its provider scope.
 */
@ngCore.Injectable()
export class Store extends ComponentStore<State> {
  /** Selector for {@link State.presentPageConfiguration} */
  public readonly presentPageConfigurationSg = this.selectSignal(
    _state => _state.presentPageConfiguration,
  )

  /** @see {@link state.mosaic.dev.pages.Collection} */
  private readonly _pagesEc = ngCore.inject(state.mosaic.dev.pages.Collection)

  /** Selector for {@link State.editingPageConfiguration} */
  public editingPageConfigurationSg = this.selectSignal(
    _state => _state.editingPageConfiguration,
  )

  constructor() {
    super(State.INITIAL)

    /**
     * Whenever the current editing page is changed, update the editing page
     * configuration
     */
    ngCore.effect(() => {
      const editingPage =
        this._pagesEc.plugins.currentEntityPlugin.feature.selectors
          .getEditedEntity()
          .asSignal()

      if (editingPage) {
        this.patchState(() => ({
          editingPageConfiguration: editingPage,
        }))
      } else {
        this.patchState({ editingPageConfiguration: {} })
      }
    })
  }

  /** Updates state for Editing Page configuration */
  public updateEditingPageConfiguration(
    editingPageConfigurationUpdates: Partial<
      Omit<
        ents.core.mosaic.Page.Input | ents.core.mosaic.Page.Updates,
        'content'
      >
    >,
  ) {
    this.patchState(({ editingPageConfiguration }) => ({
      editingPageConfiguration: {
        ...editingPageConfiguration,
        ...editingPageConfigurationUpdates,
      },
    }))
  }
}
